import { useParams } from 'react-router-dom'

export const DOUYIN_SHUIJU_STORE_ID = 'dy-beddypop-shuiju'
export const DOUYIN_YOUHE_STORE_ID = 'dy-beijuxiong-youhe'

export const DOUYIN_STORE_IDS = new Set([
  DOUYIN_SHUIJU_STORE_ID,
  DOUYIN_YOUHE_STORE_ID,
])

export function normalizeDouyinStoreId(storeId?: string) {
  return storeId && DOUYIN_STORE_IDS.has(storeId) ? storeId : DOUYIN_SHUIJU_STORE_ID
}

export function useDouyinStoreId() {
  const { storeId } = useParams<{ storeId: string }>()
  return normalizeDouyinStoreId(storeId)
}

export function douyinPath(storeId: string, suffix: string) {
  const normalizedSuffix = suffix.startsWith('/') ? suffix : `/${suffix}`
  return `/douyin/${normalizeDouyinStoreId(storeId)}${normalizedSuffix}`
}

export function douyinLiveAnalysisUrl(storeId: string) {
  return `/data/douyin/${normalizeDouyinStoreId(storeId)}/live-analysis.json`
}
